(function ($) {

'use strict';

	/**
	 * Implements a handler for a menu definied in content
	 * @returns {undefined}
	 */
	$.fn.contentMenuHandler = function (config) {
		var $myThis = $(this);

		if ($myThis.length < 1) {
			return false;
		}

		var options = $.extend(true, {
			closedIndicatorImgSrc: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="20px" width="12px"><path fill="none" stroke="#000" stroke-width=".8" d="M 0 0 L 12 10 L 0 20"></path></svg>'),
			openedIndicatorImgSrc: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="12px" width="20px"><path fill="none" stroke="#000" stroke-width=".8" d="M 0 0 L 10 12 L 20 0"></path></svg>'),
			animationSpeed: 200,
		}, (config || {}));



		// add an arrow link to show/hide the submenu
		$myThis.find('li ul').each(function () {
			$(this).before('<a href="javascript:;" class="x-contmenu-arr"><img src=\'' + options.closedIndicatorImgSrc + '\' alt="' + $.i81n.text('CONTENTMENU_SUBSHOWHIDE') + '" title="' + $.i81n.text('CONTENTMENU_SUBSHOWHIDE') + '"></a>');
		});


		$myThis.find('a.x-contmenu-arr').on('click', function (e) {
			e.preventDefault();
			var $clicked = $(this);
			var isOpen = $clicked.hasClass('opened');

			if (isOpen) {
				$clicked.removeClass('opened')
						.siblings('ul')
						.slideUp(options.animationSpeed);
				$clicked.find('img').attr('src', options.closedIndicatorImgSrc);
			} else {
				var $siblingUls = $clicked.closest('li').siblings('li').find('>ul');
				if ($siblingUls.length > 0) {
					$siblingUls.slideUp(options.animationSpeed)
							.siblings('a.x-contmenu-arr')
							.removeClass('opened')
							.find('img').attr('src', options.closedIndicatorImgSrc);
				}
				$clicked.addClass('opened')
						.siblings('ul')
						.slideDown(options.animationSpeed);
				$clicked.find('img').attr('src', options.openedIndicatorImgSrc);
			}
		});

		// initialize all closed
		$myThis.find('li ul').hide(0);
		// 
		//var pageidArr = /[&?]mp=([^&]+)/.exec(location.href);
		var pageidArr = /[&?](mp|hp)=([^&]+)/.exec(location.href);
		if (pageidArr && pageidArr.length > 2) {
			var $activate = $myThis.find('a[href*="' + pageidArr[1] + '=' + pageidArr[2] + '"]').first();
			if ($activate.length > 0) {
				$activate.closest('li').addClass('active');
				var $parentUL = $activate.closest('ul');
				while ($parentUL.length > 0) {
					$parentUL.show(0)
							.siblings('a.x-contmenu-arr')
							.addClass('opened')
							.find('img').attr('src', options.openedIndicatorImgSrc);
					$parentUL = $parentUL.closest('li').closest('ul');
				}

				$activate.replaceWith('<span>' + $activate.text() + '</span>');
			}
		}

	}; // $.fn.contentMenuHandler

}(jQuery));